import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ToastProvider } from '@components/base/feedback';
import { ApiErrorToaster } from '@/shared/api/ApiErrorToaster';
import { normalizeModulePathFromHost } from '@/shared/moduleContext';
import './index.css';

// Per-module subdomains (e.g. claimflow-rec.aliadiss.com) serve the SPA
// with no /{module} segment in the path. Insert it before BrowserRouter
// boots so existing App routes and absolute /{module}/* links keep
// matching. No-op on kusudama-rec and on localhost.
normalizeModulePathFromHost();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <ApiErrorToaster />
          <App />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);
